import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useForm } from "react-hook-form";
import { UsersSelect } from "shared";
import { useAddTeamUserByIdMutation } from "entitites/teams/api/teamsApi";

export const AddUserModal = ({
  open,
  handleClose,
  teamId,
}: {
  open: boolean;
  handleClose: () => void;
  teamId: string;
}) => {
  const [add] = useAddTeamUserByIdMutation();
  const { handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      users: [] as string[],
    },
  });

  return (
    <Modal
      disableScrollLock={true}
      open={open}
      onClose={() => {
        reset();
        handleClose();
      }}
      aria-labelledby="employee-modal-title"
      aria-describedby="employee-modal-description"
    >
      <Box
        onSubmit={handleSubmit((data) => {
          add({ teamId, users: data.users })
            .unwrap()
            .then(() => {
              reset();
              handleClose();
            })
            .catch((err) => console.log(err));
        })}
        component="form"
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2.5}
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          width: 825,
          maxHeight: "90%",
          bgcolor: "background.paper",
          borderRadius: "4px",
          boxShadow: 24,
          p: 3.25,
          px: 10,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 0, right: 0 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          fontWeight={700}
          id="employee-modal-title"
          variant="h6"
          component="h2"
        >
          Добавление пользователей
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          fontWeight={600}
          width="100%"
        >
          Сотрудники
          <UsersSelect
            onChange={(data) =>
              setValue(
                "users",
                data.map((i: any) => i?.id)
              )
            }
            isMultiple={true}
          />
        </Box>
        <Box display="flex" gap={2}>
          <Button
            disableElevation
            onClick={() => {
              reset();
              handleClose();
            }}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: "text.primary",
            }}
            variant="outlined"
          >
            Назад
          </Button>
          <Button
            type="submit"
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
            }}
            variant="contained"
          >
            Добавить
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
